// Errors the browser reports itself, not reasons the API gave.
const TRANSPORT_ERRORS = /^(Network Error|Request aborted|timeout of \d+ms exceeded)$/;

// True when a request gave up waiting: the server may still be working on it.
export const isTimeout = (error) => typeof error === "string" && /^timeout of \d+ms exceeded$/.test(error);

// Why the API refused a request, to show the user (the app's apiErrorMessage).
// manager.js rejects with the response body, which is plain text or an object
// with message/msg, or with the network error's message. Anything else (a
// network failure, an HTML error page, an error thrown here) gives the fallback.
export const apiMessage = (error, fallback) => {
  if (error instanceof Error) return fallback;
  const text = typeof error === "string" ? error : error?.message || error?.msg;
  if (typeof text !== "string") return fallback;
  const message = text.trim();
  if (!message || message.length > 200 || message.includes("<") || TRANSPORT_ERRORS.test(message)) return fallback;
  return message;
};
